
export const search = (() => {
    document.addEventListener("DOMContentLoaded", function () {
        const urlParams = new URLSearchParams(window.location.search);
        const pageNo = parseInt(urlParams.get("pageNo"));

        if (!isNaN(pageNo) && pageNo !== 1) {
            const container = document.getElementById("searchResults");

            if (container) {
                const items = container.querySelectorAll("li");
                const targetIndex = (pageNo - 1) * 10;
                if (items.length > targetIndex) {
                    const targetItem = items[targetIndex];

                    if (targetItem) {
                        targetItem.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }
                }
            }
        }
    });
})();
